import React, { useEffect } from 'react';
import { Sparkles, ArrowRight } from 'lucide-react';
import { storeInfluencerCoupon, normalizeCouponCode } from '../utils/influencerAttribution';

const InfluencerReferralLandingView = ({ promoCode, setActiveView, showNotification }) => {
  const code = normalizeCouponCode(promoCode);

  useEffect(() => {
    if (code) storeInfluencerCoupon(code);
  }, [code]);

  const goSignup = () => {
    if (code) storeInfluencerCoupon(code);
    setActiveView?.('signup');
  };

  const goHome = () => {
    if (code) storeInfluencerCoupon(code);
    setActiveView?.('home');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-violet-50 via-white to-fuchsia-50 flex items-center justify-center px-4 py-12">
      <div className="max-w-lg w-full bg-white rounded-3xl shadow-xl border border-violet-100 p-8 sm:p-10 text-center">
        <div className="inline-flex p-4 bg-gradient-to-r from-violet-500 to-fuchsia-500 rounded-2xl mb-6">
          <Sparkles className="w-10 h-10 text-white" />
        </div>
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3">
          Welcome to Fashdeck
        </h1>
        <p className="text-gray-600 mb-6">
          You were invited with promo code{' '}
          <span className="font-mono font-semibold text-violet-700 bg-violet-50 px-2 py-0.5 rounded">
            {code || '—'}
          </span>
          . Use it at checkout for a discount on plans and credit packs.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            type="button"
            onClick={goSignup}
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-gradient-to-r from-violet-600 to-fuchsia-600 text-white font-semibold rounded-xl hover:opacity-95 transition"
          >
            Get started
            <ArrowRight size={18} />
          </button>
          <button
            type="button"
            onClick={goHome}
            className="inline-flex items-center justify-center px-6 py-3 border border-gray-200 text-gray-700 font-medium rounded-xl hover:bg-gray-50 transition"
          >
            Explore first
          </button>
        </div>
        {showNotification && code && (
          <p className="text-xs text-gray-400 mt-6">Promo code saved for your account and checkout.</p>
        )}
      </div>
    </div>
  );
};

export default InfluencerReferralLandingView;
